import { api } from "../api";
import { createApiHook } from "../utils";

export const useMatches = createApiHook((year: string) => api.listMatches(year), {
    pollInterval: 30000,
});
